import React from 'react';
import './Blog.css'
import fahim from '../../images/blog-image/fahim.jpg'
import { BsFacebook, BsLinkedin, BsInstagram, BsGithub, BsFileEarmarkPdf } from 'react-icons/bs';
import { Link } from 'react-router-dom';
import npm from '../../images/blog-image/npm.png'
import npm1 from '../../images/blog-image/npm1.jpeg'
import studyAbroad from '../../images/blog-image/study-abroad.jpg'
import visa from '../../images/blog-image/visa.jpg'
import program from '../../images/blog-image/study-program.jpg'
import useTitle from '../../Hooks/useTitle';
import resume from '../../images/blog-image/resume.png'
import code from '../../images/blog-image/code.jpeg'


import ReactPrint from 'react-to-print';
import { useRef } from 'react';



import img1 from '../../images/blog-image/blog2/1.png'
import img2 from '../../images/blog-image/blog2/2.png'
import img3 from '../../images/blog-image/blog2/3.png'
import img4 from '../../images/blog-image/blog2/4.png'
import img5 from '../../images/blog-image/blog2/5.png'
import img6 from '../../images/blog-image/blog2/6.png'
import img7 from '../../images/blog-image/blog2/7.png'
import { FaXTwitter } from 'react-icons/fa6';





import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import 'swiper/css/scrollbar';
import 'swiper/css/autoplay';


import {
    TwitterShareButton,
    FacebookShareButton,
    LinkedinShareButton,
    WhatsappShareButton,
    TwitterIcon,
    FacebookIcon,
    LinkedinIcon,
    WhatsappIcon,
} from "react-share";


import { FaArrowDown } from 'react-icons/fa';
import { useLanguage } from '../../context/LanguageContext';
SwiperCore.use([Autoplay, Pagination]);
























const Blog2Details = () => {


    const shareUrl = window.location.href
    // console.log('Current Window Location: ', window.location)
    // console.log('Current Page URL: ', window.location.href)
    // console.log('Path Name: ', window.location.pathname)


    const { language } = useLanguage();


    window.scrollTo(0, 0);
    useTitle('Blog-Worst NPM Packages You Should Not Use');


    const ref = useRef();
































































    const postUrl = `https://fahim-faysal-portfolio.netlify.app/blog2`;
    const postTitle = 'Worst NPM Packages You Should Not Use';
    const shareOnTwitter = () => {
        window.open(`https://twitter.com/intent/tweet?text=${postTitle}&url=${postUrl}`, '_blank');
    };
    const shareOnFacebook = () => {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${postUrl}`, '_blank');
    };
    const shareOnLinkedIn = () => {
        window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${postUrl}&title=${postTitle}`, '_blank');
    };









    return (
        <div className=' mt-12 lg:px-2 md:px-2 px-0 '>


            <div className='flex justify-center lg:flex-row flex-col mb-20 lg:px-0 md:px-8 px-2 lg:gap-x-3 lg:gap-y-0 gap-x-4 gap-y-20'>





                <div className=' print:hidden lg:block hidden lg:w-3/12 w-full mx-auto lg:px-4 px-1  md:left-0 fixed top-[160px]'>
                    <div className=''>
                        <div className={`bg-base-100 border-r-4 border-gray-600   rounded-lg }`}>
                            <div className="avatar flex justify-center items-center">
                                <div className="mt-2  w-[105px] rounded-full">
                                    <img className='mx-auto' src={fahim} alt='fahim' />
                                </div>
                            </div>
                            <p className='-mt-1 text-white text-2xl font-bold text-center px-6 py-3'>FAHIM FAYSAL</p>
                            <p className='-mt-1 text-[16px] text-justify px-4'>I am a full-stack developer from Bangladesh and am available to work in office or remotely.</p>
                            <p className='mt-3 text-[16px] text-amber-500 text-justify px-4'>Expert In: <span className='text-white'>ReactJS, NodeJS, MongoDB, Redux, Firebase</span></p>
                            <div className='flex justify-center items-center gap-x-4 mt-4'>
                                <div className=''>
                                    <a href='https://github.com/Fahimsakib1?tab=repositories' target='blank' className='tooltip' data-tip='GitHub'>
                                        <BsGithub className='text-white text-2xl my-2 hover:bg-black hover:text-white rounded-lg transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsGithub>
                                    </a>
                                </div>
                                <div className=''>
                                    <a href='https://www.linkedin.com/in/fahim-faysal/' target='blank' className='tooltip' data-tip='LinkedIn'>
                                        <BsLinkedin className='text-white text-2xl my-2 hover:text-blue-700 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsLinkedin>
                                    </a>
                                </div>
                                <div className=' '>
                                    <a href='https://www.instagram.com/i_fahiim/' target='blank' className='tooltip' data-tip='Instagram'>
                                        <BsInstagram className='text-white text-2xl my-2 hover:text-rose-500 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsInstagram>
                                    </a>
                                </div>
                                <div className=''>
                                    <a href='https://www.facebook.com/fahim.sakib.5' target='blank' className='tooltip' data-tip='Facebook'>
                                        <BsFacebook className='text-white text-2xl my-2 hover:text-blue-500 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsFacebook>
                                    </a>
                                </div>
                            </div>
                            <Link to='/contact'>
                                <div className='w-full mt-3 mx-auto text-center cursor-pointer'>
                                    <button className=' text-lg w-full px-16 py-2 bg-rose-700 hover:bg-rose-800 rounded-sm text-white'>Hire Me</button>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>









                <div className='lg:ml-[355px] lg:w-6/12 w-full mx-auto bg-white screen:shadow-2xl print:shadow-none md:px-6 px-2 py-8 ml-0'>

                    <div ref={ref} className='bg-white text-black mt-6'>

                        {
                            language === 'english' ?
                                <>
                                    <h2 className='font-sans lg:text-4xl md:text-4xl text-3xl text-justify font-bold text-black mb-3'>Worst NPM Packages You Should Not Use...</h2>
                                    <p className='mt-8 text-justify px-2 text-gray-800 font-serif  text-[19px]'> All developers are familiar with npm, after all, it’s the world's largest software directory. There is no entry barrier when it comes to publishing your own package to npm. Anyone with an npm user account can upload can publish user-scoped npm packages. It has over one million packages while also offering other tools and services.</p>
                                    <p className='mt-3 text-justify px-2 text-gray-800 font-serif text-[19px]'>This also opens the possibility of people pushing useless and purposeless code, but you’d think that other developers won’t download such packages but that’s not true for some of the weird and pointless packages that I’ll be listing below.</p>
                                </>
                                :
                                <>
                                    <h2 className='font-sans lg:text-[33px] md:text-[33px] text-[24px] text-justify font-bold text-black mb-3 leading-snug'>সবচেয়ে খারাপ NPM প্যাকেজ যা আপনার ব্যবহার করা উচিত নয়</h2>
                                    <p className='mt-8 text-justify px-2 text-gray-800 font-serif  text-[19px]'> সমস্ত ডেভেলপাররা npm এর সাথে পরিচিত, সর্বোপরি, এটি বিশ্বের বৃহত্তম সফ্টওয়্যার ডিরেক্টরি। npm-এ আপনার নিজস্ব প্যাকেজ প্রকাশ করার ক্ষেত্রে কোনো প্রবেশ বাধা নেই। একটি npm ব্যবহারকারী অ্যাকাউন্ট সহ যে কেউ আপলোড করতে পারেন ব্যবহারকারী-স্কোপযুক্ত npm প্যাকেজগুলি প্রকাশ করতে পারেন৷ অন্যান্য সরঞ্জাম এবং পরিষেবাগুলি অফার করার সাথে সাথে এটির এক মিলিয়নেরও বেশি প্যাকেজ রয়েছে।</p>
                                    <p className='mt-3 text-justify px-2 text-gray-800 font-serif text-[19px]'>এটি লোকেদের অকেজো এবং উদ্দেশ্যহীন কোড ঠেলে দেওয়ার সম্ভাবনাও উন্মুক্ত করে, তবে আপনি মনে করেন যে অন্যান্য বিকাশকারীরা এই জাতীয় প্যাকেজগুলি ডাউনলোড করবে না তবে এটি কিছু অদ্ভুত এবং অর্থহীন প্যাকেজের জন্য সত্য নয় যা আমি নীচে তালিকাভুক্ত করব.</p>
                                </>
                        }




                        {
                            language === 'english' ?
                                <div>
                                    <h1 className='mt-10 text-3xl text-start text-blue-700 font-bold'>1. true</h1>
                                    <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>Now for the serious stuff. What is the simplest solution if you require the boolean value true? Simply install the following package, and you're ready to start.</p>
                                    <img className='w-full mt-4' src={img3} alt="npm-Package" />
                                    <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>In case you were wondering, there is another program available for obtaining the false value. Don't worry you're all set. Npm has more ridiculous packages that will make you laugh... 😁</p>
                                </div>
                                :
                                <div>
                                    <h1 className='mt-10 text-3xl text-start text-blue-700 font-bold'>1. true</h1>
                                    <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>এখন গুরুতর জিনিস জন্য. আপনার যদি বুলিয়ান মান সত্যের প্রয়োজন হয় তবে সবচেয়ে সহজ সমাধান কি? কেবল নিম্নলিখিত প্যাকেজটি ইনস্টল করুন এবং আপনি শুরু করতে প্রস্তুত৷</p>
                                    <img className='w-full mt-4' src={img3} alt="npm-Package" />
                                    <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>যদি আপনি ভাবছিলেন, মিথ্যা মান পাওয়ার জন্য অন্য একটি প্রোগ্রাম উপলব্ধ রয়েছে। চিন্তা করবেন না আপনি প্রস্তুত। এনপিএম-এর আরও হাস্যকর প্যাকেজ রয়েছে যা আপনাকে হাসতে বাধ্য করবে... 😁</p>
                                </div>
                        }


                        {
                            language === 'english' ?
                                <div>
                                    <h1 className='mt-10 text-3xl text-start text-blue-700 font-bold'>2. false</h1>
                                    <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>Here we present the most wanted value of all time... hahahaha</p>
                                    <img className='w-full mt-4' src={img4} alt="npm-Package" />
                                    <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>And don’t be disrespectful because around 300 people think that this package will help their project. LOL</p>
                                </div>
                                :
                                <div>
                                    <h1 className='mt-10 text-3xl text-start text-blue-700 font-bold'>2. false</h1>
                                    <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>এখানে আমরা সর্বকালের সবচেয়ে কাঙ্ক্ষিত মান উপস্থাপন করছি... হাহাহা</p>
                                    <img className='w-full mt-4' src={img4} alt="npm-Package" />
                                    <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>এবং অসম্মান করবেন না কারণ প্রায় 300 জন মনে করেন যে এই প্যাকেজটি তাদের প্রকল্পে সহায়তা করবে। হাঃ হাঃ হাঃ</p>
                                </div>
                        }


                        {
                            language === 'english' ?
                                <div>
                                    <h1 className='mt-10 text-3xl text-start text-blue-700 font-bold'>3. is-ten-thousand</h1>
                                    <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>Don't worry npm is not going to charge you money. This is a package that lets you check if a particular number is 10000 or not</p>
                                    <img className='w-full mt-4' src={img1} alt="npm-Package" />
                                    <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>What will happen if a number is not ten thousand (10,0000)? Don't worry your problem has already been solved before your thinking.. See the below package. How fast npm is. Isn't it? 😊</p>
                                </div>
                                : <div>
                                    <h1 className='mt-10 text-3xl text-start text-blue-700 font-bold'>3. is-ten-thousand</h1>
                                    <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>চিন্তা করবেন না npm আপনার থেকে টাকা নিবে না। এটি একটি প্যাকেজ যা আপনাকে একটি নির্দিষ্ট সংখ্যা 10000 কিনা তা পরীক্ষা করতে দেয়</p>
                                    <img className='w-full mt-4' src={img1} alt="npm-Package" />
                                    <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>একটি সংখ্যা দশ হাজার (10,0000) না হলে কী হবে? চিন্তা করবেন না আপনার চিন্তার আগেই আপনার সমস্যার সমাধান হয়ে গেছে.. নিচের প্যাকেজটি দেখুন। এনপিএম কত দ্রুত। তাই না? 😊</p>
                                </div>
                        }


                        {
                            language === 'english' ?
                                <div>
                                    <h1 className='mt-10 text-3xl text-start text-blue-700 font-bold'>4. is-not-ten-thousand</h1>
                                    <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>This valuable package will help to determine the number which is not ten thousand...</p>
                                    <img className='w-full mt-4' src={img2} alt="npm-Package" />
                                    <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>Let's move on to next awesome package</p>
                                </div>
                                :
                                <div>
                                    <h1 className='mt-10 text-3xl text-start text-blue-700 font-bold'>4. is-not-ten-thousand</h1>
                                    <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>এই মূল্যবান প্যাকেজটি দশ হাজার নয় এমন সংখ্যা নির্ধারণ করতে সাহায্য করবে...</p>
                                    <img className='w-full mt-4' src={img2} alt="npm-Package" />
                                    <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>আসুন পরবর্তী দুর্দান্ত প্যাকেজে চলে যাই</p>
                                </div>
                        }

                        {
                            language === 'english' ?
                                <div>
                                    <h1 className='mt-10 text-3xl text-start text-blue-700 font-bold'>5. meaning-of-life</h1>
                                    <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>Are you broken? Your girl friend left you? You are not well dealing with your life. Don't worry npm is here to teach you the real meaning of life...</p>
                                    <img className='w-full mt-4' src={img5} alt="npm-Package" />
                                    <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>Move to next package</p>
                                </div>
                                : <div>
                                    <h1 className='mt-10 text-3xl text-start text-blue-700 font-bold'>5. meaning-of-life</h1>
                                    <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>আপনি কি ভেঙ্গে পড়েছেন? তোমার প্রেমিকা তোমাকে ছেড়ে চলে গেছে? আপনি আপনার জীবনের সাথে ভাল আচরণ করছেন না. চিন্তা করবেন না এনপিএম আপনাকে জীবনের আসল অর্থ শেখাতে এসেছে...</p>
                                    <img className='w-full mt-4' src={img5} alt="npm-Package" />
                                    <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>পরবর্তী প্যাকেজে যান</p>
                                </div>
                        }


                        {
                            language === 'english' ?
                                <div>
                                    <h1 className='mt-10 text-3xl text-start text-blue-700 font-bold'>6. is-odd</h1>
                                    <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>Are you facing problem with odd numbers? (I Know you don't). This package will help you to check if a number is odd out of your head.</p>
                                    <img className='w-full mt-4' src={img6} alt="npm-Package" />
                                    <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>Move to next package</p>
                                </div>
                                :
                                <div>
                                    <h1 className='mt-10 text-3xl text-start text-blue-700 font-bold'>6. is-odd</h1>
                                    <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>আপনি কি বিজোড় সংখ্যা নিয়ে সমস্যার সম্মুখীন হচ্ছেন? (আমি জানি আপনি না) এই প্যাকেজটি আপনাকে একটি সংখ্যা আপনার মাথা থেকে বিজোড় আছে কিনা তা পরীক্ষা করতে সাহায্য করবে।</p>
                                    <img className='w-full mt-4' src={img6} alt="npm-Package" />
                                    <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>পরবর্তী প্যাকেজে যান</p>
                                </div>
                        }


                        {
                            language === 'english' ?
                                <div>
                                    <h1 className='mt-10 text-3xl text-start text-blue-700 font-bold'>7. is-is-odd</h1>
                                    <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>If you are extremely conscientious about your code and want to ensure that your is-odd function is indeed an is-odd function, here is another package to test that.</p>
                                    <img className='w-full mt-4' src={img7} alt="npm-Package" />
                                    <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>now you know some of the most valuable npm packages out there... Don't share with your friends... 😁</p>
                                </div>
                                :
                                <div>
                                    <h1 className='mt-10 text-3xl text-start text-blue-700 font-bold'>7. is-is-odd</h1>
                                    <p className='mt-3 text-justify px-2 text-gray-800  text-[17px]'>আপনি যদি আপনার কোড সম্পর্কে অত্যন্ত বিবেকবান হন এবং নিশ্চিত করতে চান যে আপনার is-odd ফাংশনটি আসলেই একটি is-odd ফাংশন, এটি পরীক্ষা করার জন্য এখানে আরেকটি প্যাকেজ রয়েছে।</p>
                                    <img className='w-full mt-4' src={img7} alt="npm-Package" />
                                    <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>এখন আপনি সেখানে কিছু মূল্যবান এনপিএম প্যাকেজ জানেন... আপনার বন্ধুদের সাথে শেয়ার করবেন না... 😁</p>
                                </div>
                        }

                    </div>


                    <ReactPrint trigger={() => <button className='print:hidden ml-3 hover:scale-105 mt-28 mb-16 px-6 py-2 bg-green-600 text-white'>
                        <div className='text-[16px] text-white flex justify-start items-center gap-x-1'>
                            <BsFileEarmarkPdf size={25} className='text-white'></BsFileEarmarkPdf>
                            {
                                language === 'english' ?
                                    <p>Download PDF</p>
                                    :
                                    <p>ডাউনলোড পিডিএফ</p>
                            }
                        </div>
                    </button>} content={() => ref.current}>

                    </ReactPrint>





                    {
                        language === 'english' ?
                            <h1 className='print:hidden mt-20 lg:mb-4 mb-3 md:text-3xl text-2xl text-start text-black font-bold'>Share This Post</h1>
                            :
                            <h1 className='print:hidden mt-20 lg:mb-4 mb-3 md:text-3xl text-2xl text-start text-black font-bold'>পোস্টটি শেয়ার করুন</h1>
                    }
                    <div className='print:hidden flex justify-start items-center'>
                        <div className='hover:scale-110 hover:duration-200 hover:delay-150 ease-out hover:-translate-y-1 cursor-pointer tooltip' data-tip='Share on Facebook'>
                            <FacebookShareButton
                                url={shareUrl}
                                quote={'Share Blog on Facebook'}
                                hashtag={'#blog'}
                                style={{ marginRight: '7px' }}
                            >
                                <FacebookIcon size={38} round={true} />
                            </FacebookShareButton>
                        </div>
                        <div className='hover:scale-110 hover:duration-200 hover:delay-150 ease-out hover:-translate-y-1 cursor-pointer tooltip' data-tip='Share on Twitter'>
                            <TwitterShareButton
                                url={shareUrl}
                                quote={'Share Blog on Twitter'}
                                hashtag={'#blog'}
                                style={{ marginRight: '7px' }}
                            >
                                <TwitterIcon size={38} round={true} />
                            </TwitterShareButton>
                        </div>
                        <div className='hover:scale-110 hover:duration-200 hover:delay-150 ease-out hover:-translate-y-1 cursor-pointer tooltip' data-tip='Share on LinkedIn'>
                            <LinkedinShareButton
                                url={shareUrl}
                                quote={'Share Blog on LinkedIn'}
                                hashtag={'#blog'}
                                style={{ marginRight: '7px' }}
                            >
                                <LinkedinIcon size={38} round={true} />
                            </LinkedinShareButton>
                        </div>
                        <div className='hover:scale-110 hover:duration-200 hover:delay-150 ease-out hover:-translate-y-1 cursor-pointer tooltip' data-tip='Share on WhatsApp'>
                            <WhatsappShareButton
                                url={shareUrl}
                                quote={'Share Blog on WhatsApp'}
                                hashtag={'#blog'}
                                style={{ marginRight: '7px' }}
                            >
                                <WhatsappIcon size={38} round={true} />
                            </WhatsappShareButton>
                        </div>
                    </div>
                </div>







                <div className='print:hidden lg:w-3/12 w-full mx-auto lg:px-4 px-1 '>
                    <div className='lg:right-auto lg:fixed lg:top-[160px] lg:mr-10 relative'>
                        <div className={`bg-gray-700 rounded-sm px-3 pt-2 pb-3`}>
                            <p className='text-white text-center text-lg -mt-1 px-6 py-1'>Read More Blogs... </p>

                            <div>
                                <Link to='/blog5'>
                                    <div className=' hover:border-blue-500 cursor-pointer gap-x-3 mb-2 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-start items-center group' title='Read Blog'>
                                        <div className="avatar">
                                            <div className="w-16 rounded">
                                                <img src={program} alt='pictures' />
                                            </div>
                                        </div>
                                        <p className='text-start text-yellow-400 group-hover:text-white md:text-lg lg:text-[16px]  text-md '>4 Reasons Why Year Gap In Study Isn't End of life</p>
                                    </div>
                                </Link>

                                <Link to='/blog7'>
                                    <div className='hover:border-blue-500 cursor-pointer gap-x-3 mb-2 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-start items-center group' title='Read Blog'>
                                        <div className="avatar">
                                            <div className="w-16 rounded">
                                                <img src={resume} alt='pictures' />
                                            </div>
                                        </div>
                                        <p className='text-start md:text-lg lg:text-[16px] text-md text-yellow-400 group-hover:text-white'>How To Improve Your Resume In 9 Steps</p>
                                    </div>
                                </Link>

                                <Link to='/blog6'>
                                    <div className='hover:border-blue-500 cursor-pointer gap-x-3 mb-2 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-start items-center group' title='Read Blog'>
                                        <div className="avatar">
                                            <div className="w-16 rounded">
                                                <img src={code} alt='pictures' />
                                            </div>
                                        </div>
                                        <p className='text-start text-yellow-400 group-hover:text-white md:text-lg lg:text-[16px]  text-md '>Tips For Writing Comments In Your Code</p>
                                    </div>
                                </Link>

                                <Link to='/blog4'>
                                    <div className=' hover:border-blue-500 cursor-pointer gap-x-3 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-start items-center group' title='Read Blog'>
                                        <div className="avatar">
                                            <div className="w-16 rounded">
                                                <img src={visa} alt='pictures' />
                                            </div>
                                        </div>
                                        <p className='text-start text-yellow-400 group-hover:text-white md:text-lg lg:text-[16px]  text-md '>EveryThing You Should Know about Student Visa</p>
                                    </div>
                                </Link>





                                {/* <div className=' -mt-12 lg:w-[300px] md:w-[680px] sm:w-[350px] w-[350px]  '>
                                    <Swiper
                                        pagination={{
                                            clickable: true
                                        }}
                                        modules={[Pagination, Autoplay, Navigation]}
                                        autoplay={{ delay: 2000 }}
                                        className="mySwiper"
                                    >

                                        <SwiperSlide className=''>
                                            <div>
                                                <Link to='/blog5'>
                                                    <div className=' hover:border-blue-500 lg:w-[300px] md:w-[680px] w-[350px] cursor-pointer gap-x-3 mb-3 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-center items-center'>
                                                        <div className="avatar">
                                                            <div className="w-16 rounded">
                                                                <img src={program} alt='pictures' />
                                                            </div>
                                                        </div>
                                                        <p className='text-start text-yellow-400 underline md:text-lg lg:text-[16px]  text-md '>4 Reasons Why Year Gap In Study Isn't End of life</p>
                                                    </div>
                                                </Link>
                                                <Link to='/blog3'>
                                                    <div className='hover:border-blue-500 lg:w-[300px] md:w-[680px] w-[350px] cursor-pointer gap-x-3 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-center items-center'>
                                                        <div className="avatar">
                                                            <div className="w-16 rounded">
                                                                <img src={studyAbroad} alt='pictures' />
                                                            </div>
                                                        </div>
                                                        <p className='text-start text-yellow-400 underline md:text-lg lg:text-[16px]  text-md'>Why Study Abroad? Stories From International Students</p>
                                                    </div>
                                                </Link>

                                            </div>
                                        </SwiperSlide>


                                        <SwiperSlide className=''>
                                            <div>


                                                <Link to='/blog6'>
                                                    <div className=' hover:border-blue-500 lg:w-[300px] md:w-[680px] w-[350px] cursor-pointer gap-x-3 mb-3 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-center items-center'>
                                                        <div className="avatar">
                                                            <div className="w-16 rounded">
                                                                <img src={code} alt='pictures' />
                                                            </div>
                                                        </div>
                                                        <p className='text-start text-yellow-400 underline md:text-lg lg:text-[16px]  text-md '>Tips For Writing Comments In Your Code</p>
                                                    </div>
                                                </Link>

                                                <Link to='/blog4'>
                                                    <div className=' hover:border-blue-500 lg:w-[300px] md:w-[680px] w-[350px] cursor-pointer gap-x-3 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-center items-center'>
                                                        <div className="avatar">
                                                            <div className="w-16 rounded">
                                                                <img src={visa} alt='pictures' />
                                                            </div>
                                                        </div>
                                                        <p className='text-start text-yellow-400 underline md:text-lg lg:text-[16px]  text-md '>EveryThing You Should Know about Student Visa</p>
                                                    </div>
                                                </Link>

                                            </div>
                                        </SwiperSlide>

                                    </Swiper>
                                </div> */}


                            </div>
                        </div>
                    </div>
                </div>




            </div>


        </div>
    );
};

export default Blog2Details;